import { decode } from "jsonwebtoken";
/**
 * Decode JWT and return an additional `expired` flag so we can regenerate the session.
 */
function getJwtPayload(jwt) {
  let expireBeforeDays = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
  const decoded = decode(jwt);
  const isValidUntil = new Date(decoded.validUntil);
  const expiresIn = isValidUntil.getTime() - 1000 * 60 * 60 * 24 * expireBeforeDays;
  return {
    ...decoded,
    isValidUntil,
    expired: new Date().getTime() >= expiresIn
  };
}
export { getJwtPayload };